export default "__VITE_ASSET__e6879262__"